import React from 'react'
import banner_image from "../Assets/images/banner_image.png";
import { Accordion } from 'react-bootstrap';

const WordPress = () => {
    return (
        <>
            <div className="wordpress_page">
                <div className="wordpress_baner">
                    <div className="container-layout">
                        <div className="row wordpress_row">
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <h1>WordPress Website Design</h1>
                                <p>
                                Welcome to the world of WordPress – the ultimate platform that revolutionizes the way websites are built and managed. Whether you're an aspiring blogger, a small business owner, or a seasoned developer, WordPress offers an unparalleled suite of tools and features to bring your digital vision to life.
                                </p>
                                <p>
                                    WordPress is an open-source platform initially designed for blogging that has evolved into a robust CMS. It powers a significant portion of the internet due to its flexibility, user-friendly interface, and extensive customization options.
                                </p>

                                {/* <ul className="breadcrumb mt-4">
                                    <li><a href="/">Home</a></li>
                                    <li>WordPress Website Design</li>
                                </ul> */}
                            </div>

                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div className="right_img">
                                    <img src={banner_image} alt='service_baner' />
                                </div>

                            </div>
                        </div>

                        <div className="number_sec">
                            <div className="row">
                                <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                    <div className="number_item border_right">
                                        <span>165</span>
                                        <span className="super">+</span>
                                        <h6>Support Given</h6>
                                    </div>

                                </div>

                                <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                    <div className="number_item border_right">
                                        <span>254</span>
                                        <span className="super">+</span>
                                        <h6>Clients Rating</h6>
                                    </div>

                                </div>

                                <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                    <div className="number_item border_right">
                                        <span>2M</span>
                                        <span className="super">+</span>
                                        <h6>Money Saved</h6>
                                    </div>

                                </div>

                                <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                    <div className="number_item">
                                        <span>145 </span>
                                        <span className="super">+</span>
                                        <h6>Happy Clients</h6>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>


                {/* <div className="container-layout">
                        <div className="number_sec">
                            <div className="row">
                                <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                    <div className="number_item border_right">
                                        <span>165</span>
                                        <span className="super">+</span>
                                        <h6>Support Given</h6>
                                    </div>

                                </div>

                                <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                    <div className="number_item border_right">
                                        <span>254</span>
                                        <span className="super">+</span>
                                        <h6>Clients Rating</h6>
                                    </div>

                                </div>

                                <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                    <div className="number_item border_right">
                                        <span>2M</span>
                                        <span className="super">+</span>
                                        <h6>Money Saved</h6>
                                    </div>

                                </div>

                                <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3">
                                    <div className="number_item">
                                        <span>145 </span>
                                        <span className="super">+</span>
                                        <h6>Happy Clients</h6>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div> */}

                <div className="sec_width">
                    <div className="description_sec">
                        <div className="container-layout">
                            <div className="row">
                                <div className="col-md-12 col-lg-12 col-xl-12">
                                    <p className='text-center primary_text'>AVAIL UNIQUE WORDPRESS WEBSITE DESIGNING SERVICES </p>
                                    <h2 className='text-center'><span>WordPress</span> Website Designing</h2>
                                    <p className='text-center mt-4'>
                                        WordPress is one of the most renowned and efficient platforms that offer a free CMS system. Are you interested in developing your website using WordPress? If yes, then you have come to the right place. We are diligent in managing the CMS system of WordPress without any hassle. Our web designing services are not limited to PHP only, but we also provide WordPress website design services. With our team of expert designers, one can enjoy thousands of WordPress templates, plugins for your site and get your website more attractive, all because of our WordPress web designing solutions.
                                    </p>

                                    <p className='text-center'>
                                        We are a home to an entire team of appreciated web designers & developers, helping several businesses in getting a responsive and user-friendly WordPress website. Custom web design and responsive design ideas are our aims to go with. We will help you with the customization of a WordPress website if you have or can help you with the WordPress Website Design Creation with the best ideas.
                                    </p>

                                    <p className='text-center'>
                                        No matter whether you desire to sell products on the web or create leads, a WordPress website design can help you easily. Moreover, WordPress also gives your customers a reason to choose you because your site can adjust to the screen’s size regardless of the device. So, use our WordPress website designing services under the guidance of our CMS expert designers and make your WordPress website responsive and eye-catching and boost your online reputation and generate customers.
                                        Build your WordPress website now.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className="faq_Sec">
                        <div className="container-layout">
                            <h2 className='text-center'>Frequently Asked <span>Questions</span></h2>
                            <p className='text-center'>A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradise</p>
                            <div className="row faq_row">
                                <div className="col-md-12 col-lg-12 col-xl-12">

                                    <div className="faq_accordion">
                                        <Accordion defaultActiveKey="">

                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header> How to Change my Photo from Admin Dashboard? </Accordion.Header>
                                                <Accordion.Body>
                                                    Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast.
                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header> How to Change my Password easily?</Accordion.Header>
                                                <Accordion.Body>
                                                    Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast
                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header> How to Change my Subscription Plan using PayPal?</Accordion.Header>
                                                <Accordion.Body>
                                                    Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast
                                                </Accordion.Body>
                                            </Accordion.Item>




                                        </Accordion>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </>
    )
}

export default WordPress